import { Component, Input, ViewChild } from "@angular/core";
//interfaces
import { ICourseSession } from "src/app/attendanceRecord/interfaces/SessionsInterface";
import { GeneralEmptyModalComponent } from "src/app/shared/modals/general-empty-modal/general-empty-modal.component";
import { ModalConfig } from "src/app/shared/modals/modal.interfaces";

@Component({
  selector: "app-my-qrs-catalog",
  templateUrl: "./my-qrs-catalog.component.html",
  styleUrls: ["./my-qrs-catalog.component.css"],
})
export class MyQrsCatalogComponent {
  @Input()
  sessions: ICourseSession[] = [];
  @Input() userMap: { [key: string]: string } = {};
  @Input() showOwner: boolean = false;

  @ViewChild("modal")
  public qrModal!: GeneralEmptyModalComponent;
  public selectedSesion: ICourseSession | null = null;
  public isMyQRModel: boolean = false;
  public isShareModel: boolean = false;

  private modalBasicTitle: string = "QR de la sesión";

  public modalConfig: ModalConfig = {
    modalTitle: this.modalBasicTitle,
    hideDismissButton: true,
    hideCloseButton: true,
    ngModalOptions: {
      centered: true,
      size: "lg",
      backdrop: "static",
    },
  };
  getUserName(personNumber: string): string {
    return this.userMap[String(personNumber)] ?? "Sin asignar";
  }

  constructor() {}

  async openModalType(
    selectedSession: ICourseSession,
    modalType: "myQR" | "shareQR"
  ) {
    this.modalConfig.modalTitle = `${selectedSession.titulo} - ID Localizador: ${selectedSession.IdLocalizador}`;
    this.selectedSesion = selectedSession;
    if (modalType === "myQR") {
      this.isMyQRModel = true;
      this.isShareModel = false;
    } else if (modalType === "shareQR") {
      this.isMyQRModel = false;
      this.isShareModel = true;
    } else {
      this.isMyQRModel = false;
      this.isShareModel = false;
    }
    await this.qrModal.open();
  }

  async closeModal() {
    this.selectedSesion = null;
    await this.qrModal.close();
  }

  async shareWith(selectedSession: ICourseSession) {
    this.selectedSesion = selectedSession;
    await this.openModalType(selectedSession, "shareQR");
  }

  async myQRs(selectedSession: ICourseSession) {
    this.selectedSesion = selectedSession;
    await this.openModalType(selectedSession, "myQR");
  }
}
